import { DownloadOutlined } from '@ant-design/icons'
import { Button } from 'design-system/button/Button'
import React from 'react'
import { CensusCsvRowDownloadType } from '../api/census-enrollment-platform-api-client'
import { useDownloadCMv2RowReport } from '../hooks/useDownloadCMv2RowReport'

interface DownloadCensusReportButtonProps {
  publicKey: string
  rowType: CensusCsvRowDownloadType | 'ACTIVITY'
}

const DownloadCensusReportButton = ({
  publicKey,
  rowType,
}: DownloadCensusReportButtonProps) => {
  const { loading, downloadReport } = useDownloadCMv2RowReport()

  const handleDownload = () => {
    downloadReport(publicKey, rowType)
  }

  return (
    <Button
      onClick={handleDownload}
      variant="darkblue"
      type="outline"
      size="large"
      loading={loading}
    >
      <DownloadOutlined style={{ marginRight: '8px' }} />
      Download Report
    </Button>
  )
}

export default DownloadCensusReportButton
